import React from 'react'
import SkeletonTiles from './SkeletonTiles'

const TiledMenuSkeleton = ({ windowHeight, headerHeight }) => (
  <div
    className='bg-ghost-grey overflow-y-auto scrolling-container'
    style={{ maxHeight: `${windowHeight - headerHeight}px` }}
  >
    <div className='layout-width-constraint pt8 pa7'>
      <nav>
        <SkeletonTiles tileCount={28} />
      </nav>
    </div>
  </div>
)

export default TiledMenuSkeleton
